import { BookingEntry } from "../types/BookingEntry";

export enum BookingDisplayType {
  invoice = "Rechnung",
  creditNote = "Gutschrift",
  payment = "Auszahlung",
  deposit = "Einzahlung",
  unknown = "",
}

export const getDisplayedType = (bookingEntry: BookingEntry): string => {
  if (bookingEntry.type === "invoice" && bookingEntry.debitOrCredit === "debit") {
    return BookingDisplayType.invoice;
  }
  if (bookingEntry.type === "invoice" && bookingEntry.debitOrCredit === "credit") {
    return BookingDisplayType.creditNote;
  }
  if (bookingEntry.type === "payment" && bookingEntry.debitOrCredit === "debit") {
    return BookingDisplayType.payment;
  }
  if (bookingEntry.type === "payment" && bookingEntry.debitOrCredit === "credit") {
    return BookingDisplayType.deposit;
  }
  return BookingDisplayType.unknown;
};
